import { AxiosError } from 'axios';

import { queryKeys } from '@/tanstack-query/query-keys';
import { Supplier } from '@/types/supplier';
import { useQuery } from '@tanstack/react-query';

import { RequestService } from '../services/request.service';

/** Получение поклажедателя */
export const getSupplier = async (id?: number | string) => {
	const request = RequestService.getInstance();
	try {
		const { data } = await request.get<Supplier>(`/api_v1/depositor/${id}/`);
		return data;
	} catch (error) {
		if (error instanceof AxiosError) {
			console.log(error?.response?.data);
		} else {
			console.log(error);
		}
		throw error;
	}
};

export const useSupplier = (id?: number | string) =>
	useQuery({
		queryKey: [...queryKeys.supplier, id],
		queryFn: () => getSupplier(id),
		enabled: !!id,
	});
